import moment from 'moment';
export var getStartDate = function (event, format) {
    try {
        if (event.scheduling.config.startDate) {
            var startDate = new Date(event.scheduling.config.startDate);
            return moment(startDate).format(format);
        }
    }
    catch (e) {
        return;
    }
};
//# sourceMappingURL=helpers.js.map